import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable} from "rxjs/Observable";
const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    'Authorization': 'my-auth-token'
  })
};
@Injectable()
export class NewsService {
  url: string = "http://api.planificacion.gob.bo/api/";
  domain: string = "http://www.planificacion.gob.bo/";
  urlVipfe:string = "https://rest.vipfe.gob.bo";
  constructor(private http: HttpClient) { }
  getNews(): Observable<any> {
    return this.http.get(this.url + 'news');
  }
  getNew(id): Observable<any> {
    return this.http.get(this.url + 'news/' + id);
  }
  getBanner(): Observable<any> {
    return this.http.get(this.url + 'news/banner');
  }
  getMenus(): Observable<any> {
    return this.http.get(this.url + 'news/menu/');
  }
  getContent(id): Observable<any> {
    return this.http.get(this.url + 'news/content/' + id);
  }
  getnewsPages(page): Observable<any> {
    return this.http.get(this.url + 'news/noticias/' + page);
  }
  getPopup(): Observable<any> {
    return this.http.get(this.url + 'news/popup');
  }
  getConfig(): Observable<any> {
    return this.http.get('./assets/config.json');
  }
  getVideos(): Observable<any> {
    return this.http.get(this.url + 'news/video/');
  }
  verify(code): Observable<any> {
    return this.http.get(this.url + 'forms/verify/' + code);
  }
  getParams(): Observable<any> {
    return this.http.get(this.url + 'forms/');
  }
  send(data): Observable<any> {
    return this.http.post(this.url + 'forms/', data , httpOptions);
  }
  register(data): Observable<any> {
    return this.http.post(this.urlVipfe + '/paginawebmpd/registro', data , httpOptions);
  }

  evento(): Observable<any> {
    return this.http.get(this.urlVipfe + '/paginawebmpd/evento');
  }

}



// WEBPACK FOOTER //
// ./src/app/services/news.service.ts